import { render, staticRenderFns } from "./clear-realname.vue?vue&type=template&id=375290ea&"
import script from "./clear-realname.vue?vue&type=script&lang=js&"
export * from "./clear-realname.vue?vue&type=script&lang=js&"
import style0 from "./clear-realname.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports